import { defineMessages } from "react-intl";

const planMessages = defineMessages({
  enterprise1: {
    id: "billing.information.plans.enterprise.1",
    defaultMessage: "AI Routing & Field View",
  },
  enterprise2: {
    id: "billing.information.plans.enterprise.2",
    defaultMessage: "Lead Finder Elite (200 searches/user/mo)",
  },
  enterprise3: {
    id: "billing.information.plans.enterprise.3",
    defaultMessage: "CRM Sync: Two-way & Open API",
  },
  enterpriseSubtitle: {
    id: "billing.information.plans.enterprise.subtitle",
    defaultMessage: "Team Plan",
  },
  leader1: {
    id: "billing.information.plans.leader.1",
    defaultMessage: "Advanced Routing & Efficiency Reporting",
  },
  leader2: {
    id: "billing.information.plans.leader.2",
    defaultMessage: "Lead Finder Adv. (125 searches/user/mo)",
  },
  leader3: {
    id: "billing.information.plans.leader.3",
    defaultMessage: "CRM Sync: Two-way",
  },
  leaderSubtitle: {
    id: "billing.information.plans.leader.subtitle",
    defaultMessage: "Team Plan",
  },
  midMarket1: {
    id: "billing.information.plans.midMarket.1",
    defaultMessage: "Standard Routing & Mapping",
  },
  midMarket2: {
    id: "billing.information.plans.midMarket.2",
    defaultMessage: "Lead Finder Standard (75 searches/user/mo)",
  },
  midMarket3: {
    id: "billing.information.plans.midMarket.3",
    defaultMessage: "CRM Sync: One-Way",
  },
  midMarketSubtitle: {
    id: "billing.information.plans.midMarket.subtitle",
    defaultMessage: "Up to 25 users",
  },
});

export const planNameToInfo = {
  Enterprise: {
    extraPoints: [planMessages.enterprise1, planMessages.enterprise2, planMessages.enterprise3],
    subtitle: planMessages.enterpriseSubtitle,
  },
  "Industry Leader": {
    extraPoints: [planMessages.leader1, planMessages.leader2, planMessages.leader3],
    subtitle: planMessages.leaderSubtitle,
  },
  "Mid-Market Sales": {
    extraPoints: [planMessages.midMarket1, planMessages.midMarket2, planMessages.midMarket3],
    subtitle: planMessages.midMarketSubtitle,
  },
} as const;
